import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';

import {
  cadastroTerminalInRequest,
  deleteCadastroTerminal,
  findCadastroTerminal,
  recordFiltering,
} from '~/store/modules/cadastroterminal/actions';

import CadastroTerminalForm from './form';

function CadastroTerminal() {
  const cadastroterminal = useSelector((state) => state.cadastroterminal);

  const listaStatusPesquisa = useMemo(() => [
    { label: '1', value: 'liberado' },
    { label: '2', value: 'bloqueado' },
    { label: '3', value: 'cancelado' },
  ]);

  const header = useMemo(
    () => [
      {
        id: 'poco_descricao',
        label: 'Posto:',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
      {
        id: 'term_descricao',
        label: 'Descrição',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
      {
        id: 'term_identificacao',
        label: 'Identificação',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
      {
        id: 'term_ip',
        label: 'IP',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
      {
        id: 'term_porta',
        label: 'Porta',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
      {
        id: 'term_versao_firmware',
        label: 'Versão Firmware',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
      {
        id: 'term_controla_cbc_string',
        label: 'Controla CBC',
        filter: {
          type: 'text',
        },
        align: 'center',
      },
      {
        id: 'term_controla_lc_string',
        label: 'Controla LC',
        filter: {
          type: 'text',
        },
        align: 'center',
      },

      {
        id: 'term_status_string',
        label: 'Status',
        align: 'center',
        converter: listaStatusPesquisa,
        filter: {
          type: 'select',
          options: listaStatusPesquisa,
        },
      },
    ],
    []
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="term_descricao ASC"
        fixed
        header={header}
        redux={cadastroterminal}
        //custom={filter}
        //actions={buttons}
        keys={['poco_codigo', 'term_identificacao']}
        detach="term_identificacao"
        read={recordFiltering}
        find={findCadastroTerminal}
        remove={deleteCadastroTerminal}
        form={CadastroTerminalForm}
        view="VW_TB_TERMINAL"
        reportTitle="Cadastro de Terminal"
      />

      {/* <Tabela
        read={cadastroTerminalInRequest}
        remove={deleteCadastroTerminal}
        state={cadastroterminal}
        header={header}
        headerMobile="term_identificacao"
        unique={['poco_codigo', 'term_identificacao']}
        form={CadastroTerminalForm}
        findItem={findCadastroTerminal}
        recordFilter={recordFiltering}
      /> */}
    </>
  );
}

export default CadastroTerminal;
